const BASE_URL = "erp-recruitment/interview";

export const getEventsUrl = (screenCode) => `${BASE_URL}/${screenCode}`;

export const getCandidateInProgramUrl = (screenCode) =>
  `${BASE_URL}/${screenCode}/detail`;

export const getDetailInterviewUrl = ({ screenCode, scheduleId }) =>
  `${BASE_URL}/${screenCode}/${scheduleId}/feedback`;

export const updateStatusParticipateUrl = ({ screenCode, itemCode }) =>
  `${BASE_URL}/${screenCode}/${itemCode}/confirm/participate/panel`;

export const updateResultUrl = ({ screenCode, itemCode }) =>
  `${BASE_URL}/${screenCode}/${itemCode}/result/panel`;

export const getListProgramURL = `${BASE_URL}/program/option`;
